import styled, { css } from "styled-components";
import React, { Component, Fragment } from "react";
import CloudSearch from "mdi-material-ui/CloudSearch";
import { SearchBar } from "js/react/views/AddSlide/Panes/Components/SearchBox";
import { Gap10, Gap20 } from "js/react/components/Gap";
import { Icon, IconButton, MenuItem } from "@material-ui/core";
import { IconMenu } from "js/react/components/UiComponents";
import { themeColors } from "js/react/sharedStyles";
import { app } from "js/namespaces";
import { t } from "js/i18n";

const StyledLibraryHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    min-width: 0;
`;

const StyledSearchBar = styled(SearchBar)`
    flex: 1;
    min-width: 0;

    ${props => props.$isMobile && `
        padding: 0;
    `}
`;

const iconMenuStyles = css`
    &&& {
        padding: 0;

        .bai-icon,
        .material-icons,
        .MuiIcon-root,
        .MuiSvgIcon-root {
            color: ${themeColors.mediumGray};
            height: 18px;
            width: 18px;
            font-size: medium;
        }

        :hover {
            .bai-icon,
            .material-icons,
            .MuiIcon-root,
            .MuiSvgIcon-root {
                color: ${themeColors.ui_blue};
            }
        }
    }
`;

const StyledIconMenu = styled(IconMenu)`
    &&& {
        transform: rotate(90deg);
    }

    ${iconMenuStyles};
`;

const StyledIconButton = styled(IconButton)`
    ${iconMenuStyles};

`;

const StyledSearchIconButton = styled(IconButton)`
    &&& {
        color: ${themeColors.ui_blue};
    }
`;

export class PresentationListHeader extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showSearchBar: false,
        };

        this.searchBarRef = React.createRef();
    }

    handleSetSort = sort => {
        const { onSetSort } = this.props;
        if (onSetSort) {
            onSetSort(sort);
        }
    }

    handleSearch = value => {
        const { onSearch } = this.props;
        onSearch?.(value);
    }

    toggleViewType = () => {
        const { viewType, onSetViewType } = this.props;

        if (onSetViewType) {
            onSetViewType(viewType === "grid" ? "list" : "grid");
        }
    }

    getViewTypeIcon = () => {
        const { viewType } = this.props;
        return viewType === "grid" ? "grid_view" : "menu";
    }

    handleShowSearchBar = () => {
        this.setState({ showSearchBar: true }, () => {
            this.searchBarRef.current?.focusInput?.();
        });
    }

    handleHideSearchBar = () => {
        this.setState({ showSearchBar: false });
    }

    render() {
        const {
            onSearch,
            searchPlaceholder,
            sortOptions = [],
            viewType = "grid",
            className = "",
            sort,
            searchQuery = "",
            showViewTypeToggle = true,
        } = this.props;
        const { showSearchBar } = this.state;
        const shouldRenderSearchBar = !!onSearch && (!!showSearchBar || app.isMobileOrTablet);

        return (
            <StyledLibraryHeader className={className}>
                {onSearch && !shouldRenderSearchBar && (
                    <StyledSearchIconButton size="small" onClick={this.handleShowSearchBar}>
                        <Icon>search</Icon>
                    </StyledSearchIconButton>
                )}
                {shouldRenderSearchBar && (
                    <Fragment>
                        <StyledSearchBar
                            ref={this.searchBarRef}
                            showIcon={false}
                            placeholder={searchPlaceholder}
                            onSearch={this.handleSearch}
                            onBlurOnEmpty={this.handleHideSearchBar}
                            $isMobile={app.isMobileOrTablet}
                        />
                    </Fragment>
                )}
                {(viewType === "grid" || app.isConstrained) && (
                    <Fragment>
                        {!app.isConstrained && <Gap20 />}
                        {!app.isMobileOrTablet && app.integrator && <Gap10 />}
                        <StyledIconMenu icon="compare_arrows" $isMobile={app.isMobileOrTablet}>
                            {!searchQuery && sortOptions.map(option => (
                                <MenuItem
                                    key={option.field}
                                    selected={sort?.field === option.field}
                                    onClick={() => this.handleSetSort(option)}
                                >
                                    {option.icon && <Icon>{option.icon}</Icon>}
                                    {option.label}
                                </MenuItem>
                            ))}
                            {!!searchQuery && (
                                <MenuItem selected>
                                    <Icon><CloudSearch /></Icon>
                                    {t("Relevance")}
                                </MenuItem>
                            )}
                        </StyledIconMenu>
                    </Fragment>
                )}

                {!app.isConstrained && showViewTypeToggle && (
                    <Fragment>
                        <Gap20 />
                        <StyledIconButton onClick={() => this.toggleViewType()}>
                            <Icon>{this.getViewTypeIcon()}</Icon>
                        </StyledIconButton>
                    </Fragment>
                )}

                {app.isConstrained && showViewTypeToggle && (
                    <Fragment>
                        <StyledIconButton onClick={() => this.toggleViewType()} $isMobile={app.isMobileOrTablet}>
                            <Icon>{this.getViewTypeIcon()}</Icon>
                        </StyledIconButton>
                    </Fragment>
                )}
                <Gap10 />
            </StyledLibraryHeader>
        );
    }
}
